import React from "react";
import { Link } from "react-router-dom";
import shape from "../../images/service-shape-2.png";

import EbookSlider from "../../components/EbookSlider/EbookSlider";

const WhyChoose = (props) => {
  return (
    <section className="wpo-service-section section-padding">
      <div className="service-shape-1">
        <svg width="794" height="783" viewBox="0 0 794 783" fill="none">
          <g opacity="0.6" filter="url(#filter0_f_225_6)">
            <circle cx="534" cy="249" r="234" />
          </g>
          <defs>
            <filter
              id="filter0_f_225_6"
              x="0"
              y="-285"
              width="1068"
              height="1068"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="150"
                result="effect1_foregroundBlur_225_6"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-12 col-md-12 col-12">
            {" "}
            {/* Removido order-lg-2 */}
            <div className="service-left">
              <div className="wpo-section-title">
                <span>O que você vai receber?</span>
                <h2>
                  Uma Trilha Completa: Do Primeiro Traço à Leitura com
                  Confiança.
                </h2>
                <p className="sub-text-purple">
                  O Kit Neuroalfabetização é uma jornada passo a passo com mais
                  de 500 atividades organizadas em 16 livros digitais, prontas
                  para imprimir e usar.
                </p>
              </div>
              {/* Carrossel visível apenas em mobile/tablet */}
              <div className="d-xl-none" style={{ marginBottom: "30px" }}>
                {" "}
                {/* Adicionado margem para espaçamento */}
                <EbookSlider />
              </div>
            </div>
            <Link onClick={props.link} className="theme-btn">
              QUERO VER TODO O MATERIAL INCLUSO
            </Link>
          </div>
          {/* Carrossel visível apenas em desktop */}
          <div className="col-xl-6 col-lg-12 col-md-12 col-12 d-none d-xl-flex align-items-center">
            {" "}
            {/* Removido order-lg-1 */}
            <EbookSlider />
          </div>
        </div>
      </div>

      <div className="service-shape-2">
        <img src={shape} alt="" />
      </div>
    </section>
  );
};

export default WhyChoose;
